document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('[js-hero-banner-main]');
  const boxes = Array.from(document.querySelectorAll('[js-hero-banner-bar]'));
  const colorData = document.querySelector('[js-hero-banner-inner]')?.dataset.blockColors;
  const colors = colorData ? JSON.parse(colorData) : ["#fcddec", "#f5dc9b", "#fc9c9c"];

  let currentIndex = 0;
  let prevIndex = 0;
  const totalBoxes = boxes.length;

  function setInitialPositions() {
    boxes.forEach((box, index) => {
      const position = (index - currentIndex + totalBoxes) % totalBoxes;
      setBoxPosition(box, position, true);
    });
  }

  function setBoxPosition(box, position, instant = false) {
    const isMobile = window.innerWidth <= 767;
    let xLeft = isMobile ? -40 : -101;
    let xMiddle = 0;
    let xRight = isMobile ? 40 : 101;
    let yValue = isMobile ? 15 : 30;

    let config;
    switch (position) {
      case 0:
        config = { xPercent: -50, x: xLeft, y: yValue, scale: 0.85, rotation: -10, opacity: 1 };
        break;
      case 1:
        config = { xPercent: -50, x: xMiddle, y: 0, scale: 1, rotation: 0, opacity: 1 };
        break;
      case 2:
        config = { xPercent: -50, x: xRight, y: yValue, scale: 0.85, rotation: 10, opacity: 1 };
        break;
      default:
        config = { xPercent: -50, x: 200, y: yValue, scale: 0.8, rotation: 10, opacity: 0 };
    }

    if (instant) {
      gsap.set(box, {
        ...config,
        transformOrigin: "bottom center",
        zIndex: position === 1 ? 3 : 2,
      });
    } else {
      gsap.to(box, {
        ...config,
        transformOrigin: "bottom center",
        duration: 0.6,
        ease: "power2.inOut",
        zIndex: position === 1 ? 3 : 2,
        onStart: () => {
          if (!box.dataset.initialized) {
            box.dataset.initialized = "true";
          }
        },
      });
    }
  }

  function animateBoxes() {
    prevIndex = currentIndex;
    currentIndex = (currentIndex + 1) % totalBoxes;

    boxes.forEach((box, index) => {
      let position = (index - currentIndex + totalBoxes) % totalBoxes;
      setBoxPosition(box, position, false);
    });

    const nextColor = colors[currentIndex % colors.length];
    if (container) {
      gsap.to(container, {
        backgroundColor: nextColor,
        duration: 1.2,
        ease: "power2.inOut",
      });
    }
  }

  function startSlider() {
    setInterval(() => {
      animateBoxes();
    }, 3000);
  }

  if (boxes.length > 0) {
    setInitialPositions();
    startSlider();
  }

  window.addEventListener("resize", () => {
    setInitialPositions();
  });
});

